// import-library
import React, { Component } from 'react';

// utils
import commonUtil from '../../../../../utils/commonUtil';

// import-components
import MultiAddressItem from './multiAddressItem';
import Warning from '../../../../../components/Warning2';

const channel = commonUtil.getChannel();

class GiftRegistryMultipleAddressBody extends Component {

  constructor(props) {
    super(props);
    this.onClickOfRadioButton = this.onClickOfRadioButton.bind(this);
    this.onItemChange = this.onItemChange.bind(this);
    this.selectedAddresses = [];
    this.childControlMethods = [];
    this.formData = [];
    this.addChildControlRef = this.addChildControlRef.bind(this);
    this.state = {
     multiSelectedAddresses: [],
     predefinedAddressId: null
    };
  }

  componentDidMount() {
    this.selectedAddresses = [];
    const firstAddress = this.props.addressBook?.addresses?.[0];
    const defaultAddress = this.props.addressBook?.addresses?.find(
      (address) => address.defaultAddress,
    );
    const newAddedAddressId = sessionStorage.getItem('newAddedAddressId');

    if (this.props.successOnEdit) {
      this.alertMessage.setMessage('Los cambios realizados se verán reflejados en tu usuario Liverpool.');
    }
    let ids = [];
    if (this.props.prepopulateData && this.props.prepopulateData.length > 0) {
      this.props.prepopulateData.forEach((item) => {
        ids.push(item.address.addressId);
        this.selectedAddresses?.push(item);
        this.updateChildComponents(item);
      });
    }

    if (newAddedAddressId && this.props.addressBook?.addresses) {
      const newAddress = this.props.addressBook.addresses.find(
        (address) => address.addressId === newAddedAddressId,
      );
      if (newAddress && !ids.includes(newAddedAddressId)) {
        this.selectedAddresses?.push({ address: newAddress, priority: {} });
        ids.push(newAddedAddressId);
        this.props.defineCreateEventData(this.props.currentIndex, { data: this.selectedAddresses });
        this.updateChildComponents({ address: newAddress, chkState: true });
        sessionStorage.removeItem('newAddedAddressId');
      }
    }

    const prepopulateDataAddress = this.selectedAddresses?.[0]?.address;

    const addressToSelect = prepopulateDataAddress || defaultAddress;

    if (!ids.length) {
      if (addressToSelect) {
        this.selectedAddresses?.push({
          address: addressToSelect,
          priority: {},
        });
        ids.push(addressToSelect.addressId);
        this.props.defineCreateEventData(this.props.currentIndex, { data: this.selectedAddresses });
      }
    }

    this.setState({
      multiSelectedAddresses: ids,
      predefinedAddressId: addressToSelect ? addressToSelect.addressId : null,
    });

    this.props.setNoAddressSelected(this.selectedAddresses?.length);
  }
  setPredefinedAddress = (addressId) => {
    this.setState({ predefinedAddressId: addressId });
  };

  validated() {
    let isControlValid = true;
    if (this.selectedAddresses?.length === 0) {
      isControlValid = false;
    }
    this.childControlMethods.forEach((item) => {
      if (!item.handleOnSumbitValidation()) {
        isControlValid = false;
      }
    });
    return isControlValid;
  }
  selectedAddressforValidation() {
    let valid = false;
    if (this.selectedAddresses?.length === 0) {
      valid = true;
    }
    return valid;
  }
  onClickOfRadioButton(data) {
    let indexToRemove = 0;
    this.selectedAddresses?.forEach((item, index) => {
      if (item.address.addressId !== data.address.addressId) {
        indexToRemove = index;
      }
    });
    if (this.selectedAddresses?.length >= 1) {
      this.selectedAddresses?.splice(indexToRemove, 1);
      this.selectedAddresses?.push(data);
    } else {
      this.selectedAddresses?.push(data);
    }
    this.updateChildComponents(data);
  }

  onItemChange(data) {
    let existingItem = null;
    let indexToRemove = 0;
    this.selectedAddresses?.forEach((item, index) => {
      if (item.address.addressId === data.address.addressId) {
        existingItem = item;
        indexToRemove = index;
      }
    });
    if (data.chkState) {
      if (existingItem) {
        existingItem.address.celebrityName = data.priority.value;
        existingItem.priority = data.priority;
      } else {
        existingItem = { address: data.address, priority: data.priority };
        this.selectedAddresses?.push(existingItem);
      }
    } else {
      this.selectedAddresses?.splice(indexToRemove, 1);
    }
     this.setState((prevState) => {
    let updatedSelected = [...prevState.multiSelectedAddresses];
    const isSelected = updatedSelected.includes(data.address.addressId);

    if (data.chkState && !isSelected) {
      updatedSelected.push(data.address.addressId);
    } else if (!data.chkState && isSelected) {
      updatedSelected = updatedSelected.filter(id => id !== data.address.addressId);
    }

    let predefined = prevState.predefinedAddressId;
    if (!data.chkState && data.address.addressId === prevState.predefinedAddressId) {
      predefined = updatedSelected[0] || null; // shift predefined to next selected
    }
    if (updatedSelected.length>=1 && predefined == null) {
      predefined = updatedSelected[0]
    }
    return {
      multiSelectedAddresses: updatedSelected,
      predefinedAddressId: predefined
    };
  });
    this.props.setNoAddressSelected(this.selectedAddresses?.length);
    this.props.defineCreateEventData(this.props.currentIndex, { data: this.selectedAddresses });
    this.updateChildComponents(data);
  }

  updateChildComponents(data) {
    /* eslint-disable */
    this.childControlMethods.forEach((item) => {
      if (item.address.addressId === data.address.addressId && data.chkState === false) {
        item.addressPriority.selectedOption.selectedIndex = 0;
      }
      item.onDataUpdated(this.selectedAddresses);
    });
    /* eslint-enable */
  }

  addChildControlRef(childControl) {
    if (childControl === null) {
      return;
    }
    let exist = false;
    exist = this.childControlMethods.map(child => (child.address.addressId === childControl.address.addressId))[0];
    if (!exist) {
      this.childControlMethods.push(childControl);
    }
  }

  render() {
    // console.log("Selected Address",this.selectedAddresses);
    // console.log("Multi Selected Address",this.state.multiSelectedAddresses);
    const { lables } = this.props;
    let addressHtml = ''
    let addressLength = this.props.addressBook.addresses?.length;
    if (this.props.addressBook && this.props.addressBook.addresses) {
      addressHtml = this.props.addressBook.addresses?.map((currentAddress, index) => {
        let formData = {};
        if (this.props.prepopulateData && this.props.prepopulateData.length > 0) {
          this.props.prepopulateData.forEach((data) => {
            const newData = data;
            if (data.address.addressId === currentAddress.addressId) {
              newData.address = currentAddress;
              formData = newData;
            }
          });
        }
         const isChecked = this.state.multiSelectedAddresses?.includes(currentAddress.addressId);
          const isPredefined = this.state.predefinedAddressId === currentAddress.addressId;
        return (<div key={currentAddress.addressId} className={`${channel === 'wap' && 'p-2'}`}><MultiAddressItem onEditAddressClick={this.props.onEditAddressClick} lables={lables} currentStep={this.props.currentStep} currentIndex={this.props.currentIndex} defineCreateEventData={this.props.defineCreateEventData} currentAddress={currentAddress} formData={formData} celebName={this.props.celebName} addressToBeSelected={this.props.addressToBeSelected} forRadioButton={this.props.addressBook.addresses} index={index} optionList={this.props.prioritiesOptions} prioritiesOptions={this.props.prioritiesOptions} onSelection={this.onItemChange} onClickOfRadioButton={this.onClickOfRadioButton} ref={mItem => this.addChildControlRef(mItem)} selectedAddresses={this.selectedAddresses} removeRouteLeaveHook={this.props.removeRouteLeaveHook} isChecked={isChecked} isPredefined={isPredefined} maxAddress={this.props.maxAddress} /></div>);
      });
    }
    return (
      <React.Fragment>
        {channel === 'wap' ?
          <div className="col-xs-12">
            <Warning
              style={{ marginBottom: 25 }}
              type="warning"
              ref={alertMessage => this.alertMessage = alertMessage}
            />
            <div className="addressList" id="multiple">
              <form id="multipleAddressForm">
                {
                // this.props.addressBook && this.props.addressBook.addresses && (this.props.addressBook.addresses?.length !== 0) && 
               <React.Fragment>
                 {/* <h2>Direcciones seleccionadas <span id="change" >0 de {this.props.prioritiesOptions.length}</span></h2> */}
                 <div className='row'>
                  { addressLength > 0 ? <div style={{padding:"0px 10px"}}>{addressHtml}</div> : <div className='noAddressContainer'>
                      <div>
                        <div>
                          <img src={commonUtil.getAssetURL() + '/images/noAddres.png'} alt="No Address"/>
                        </div>
                        <p className='noAddressText'>No tienes direcciones <br/> agregadas</p>
                        <p className='saveAddressText'>Guarda tus direcciones para recibir <br/> tus compras y regalos</p>
                     </div>
                    </div>}
                </div> 
               </React.Fragment>}
              </form>
            </div>
          </div>
          :
          <div className="col-xs-12 col-md-10 col-md-offset-1">
            <Warning
              style={{ marginBottom: 25 }}
              type="warning"
              ref={alertMessage => this.alertMessage = alertMessage}
            />
            <form className="addressList" id="multiple">
              {
              // this.props.addressBook && this.props.addressBook.addresses && (this.props.addressBook.addresses?.length !== 0)
              //  &&
                <React.Fragment>
                 {/* <h2>Direcciones seleccionadas <span id="change" >0 de {this.props.prioritiesOptions.length}</span></h2> */}
                <div className="row">
                 <div className="col-xs-12">
                   { addressLength > 0 ? <div className={`${addressLength > 1 ? 'addressBoxContainer' : 'addressBoxContainerSingle' }`}>{addressHtml}</div> : <div className='noAddressContainer'>
                      <div>
                        <div >
                          <img src={commonUtil.getAssetURL() + '/images/noAddres.png'} alt="No Address"/>
                        </div>
                        <p className='noAddressText'>No tienes direcciones  agregadas</p>
                        <p className='saveAddressText'>Guarda tus direcciones para recibir tus compras y regalos</p>
                     </div>
                    </div>}
                 </div>
                </div> 
               </React.Fragment>}
            </form>
          </div>
        }
      </React.Fragment>
    );
  }
}
export default GiftRegistryMultipleAddressBody;
